import axios from 'axios'

const BUILDURL = 'https://aof-covid-19-api.hsmap.com'
const BUILDAURL = 'https://aof-covid-19-api-a.hsmap.com'
const BUILDBURL = 'https://aof-covid-19-api-b.hsmap.com'
const BUILDTESTURL = 'https://aof-covid-19-api.aihuoshi.net'

const envHandle = (env) => {
  switch(env) {
    case 'development':
      return BUILDTESTURL
    case 'production':
      return BUILDURL
    case 'a':
      return BUILDAURL
    case 'b':
      return BUILDBURL
    case 'test':
      return BUILDTESTURL
  }
}


export default ({
  url,
  method='GET',
  data,
  params,
  config
}) => {
  return axios({
    baseURL: envHandle(process.env.NODE_ENV),
    method,
    url,
    data,
    params,
    config
  }).then((res) => {
    return res.data
  }).catch(res => {
    console.log(res)
  })
}